import { ElementIds, Element } from 'types';
import { Store } from 'stores/type';

class BaseElementsManager {
  private $store!: Store;
  // helper counter for elements discovered in one check
  private count = 0;

  public init(store: Store) {
    this.$store = store;
  }

  public getInitiallyUnlocked() {
    return this.getRecentlyUnlockedIds();
  }

  public getRecentlyUnlockedIds(): ElementIds {
    this.count = 0;

    const discoveredElements = this.getDiscovered();
    // if new base element discovered then recheck to make sure
    // that all progress based conditions are correctly checked
    if (this.count !== 0) {
      return this.getDiscovered();
    }

    return discoveredElements;
  }
  private getDiscovered(): ElementIds {
    return this.lockedIds.filter((id) => {
      const element = this.$store.getters.elementById(id);
      if (!element) return false;

      const discovered = this.checkConditions(element);
      this.count += discovered ? 1 : 0;

      return discovered;
    });
  }

  public checkConditions(element: Element) {
    if (!element.hasOwnProperty('condition') || !element.condition) {
      return false;
    }

    const condition = element.condition;
    if (condition.type === 'elements') {
      return this.checkElements(condition.elements, condition.min);
    }

    if (condition.type === 'progress') {
      return this.checkProgress(condition.total);
    }

    return true;
  }

  private checkElements(elements: ElementIds, min = 0) {
    const count = elements.reduce((total, id) => {
      if (this.$store.getters.hasInProgress(id)) {
        return total + 1;
      }

      return total;
    }, 0);

    return count >= min;
  }
  private checkProgress(total: number) {
    // use helper counter of base elements discovered in this check
    // as they also count as progress
    return (this.$store.getters.totalProgress + this.count) >= total;
  }

  private get lockedIds() {
    const baseElementsIds = this.$store.getters.baseElementsIds;

    return baseElementsIds.filter((id) => {
      const element = this.$store.getters.elementById(id);
      if (!element) return false;

      // if can be discovered by any connection and as base item
      // checks unlocked base elements as well as progress
      if (element.parents.length) {
        return !this.$store.getters.hasInProgress(id);
      }

      return !this.$store.getters.hasUnlockedBase(id);
    });
  }
}

export default new BaseElementsManager();
